"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_ElementalShockFrost_OnKilledEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
let Passive_ElementalShockFrost_OnKilledEventHandlerScript = class Passive_ElementalShockFrost_OnKilledEventHandlerScript {
    run(sequence, container, handler, event) {
        const args = event.args;
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId: args.killer,
            duration: Duration_1.Duration.Ticks(16),
            effect: new core_1.ChillEffectArgs("Focus", 10)
        });
    }
};
Passive_ElementalShockFrost_OnKilledEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Passive_ElementalShockFrost_OnKilled")
], Passive_ElementalShockFrost_OnKilledEventHandlerScript);
exports.Passive_ElementalShockFrost_OnKilledEventHandlerScript = Passive_ElementalShockFrost_OnKilledEventHandlerScript;
